import { AttributeViewComponent } from 'src/app/components/attribute-view/attribute-view.component';
import { EditorAction } from './../../model/map-actions/editor-action';
import { ResultsViewComponent } from 'src/app/components/results-view/results-view.component';
import { ResultHistory } from './../../model/result-history';
import { InfoAction } from 'src/app/model/map-actions/info-action';
import { ButtonSetComponent } from './../button/button-set/button-set.component';
import { MapDataAction } from 'src/app/model/map-actions/map_data-action';
import { ActionHandlerService } from './../../services/action-handler.service';
import { Component, AfterViewInit, EventEmitter, Output, ViewChild, ViewChildren, HostBinding, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SLLayer, LayerTypeEnum, LayerAccessLevel } from 'src/app/model/sl-layer';
import { ToggleSwitchComponent } from '../toggle-switch/toggle-switch.component';
import { LayersViewComponent } from '../layers-view/layers-view.component';
import { LabelStyle } from 'src/app/types/LabelStyle';
import { ResultsPopupEditorDialogService } from '../dialogs/results-popup-editor-dialog/results-popup-editor-dialog-service';
import { ModalResultStyleService } from '../dialogs/modal-result-style/modal-result-style.service';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { ResultsLayer } from 'src/app/model/virutal-layers/results-layer';
import { DisplayAction } from 'src/app/model/map-actions/display-actions';
import { LayerAttributesViewComponent } from '../layer-attributes-view/layer-attributes-view.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { PermissionService } from 'src/app/services/permission-service';



@Component({
  selector: 'app-layer-view',
  templateUrl: './layer-view.component.html',
  styleUrls: ['./layer-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayerViewComponent implements AfterViewInit {

  @ViewChildren('app-toggle-switch') toggleSwitches: Array<ToggleSwitchComponent>;
  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() ready: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.layer-view') layerView = true;
  @HostBinding('class.work-view') workView = true;
  @HostBinding('class.is-virtual') isVirtual = false;
  @HostBinding('class.is-parent') isParent = false;
  @ViewChild('configButton', { static: true }) configButton: ElementRef;
  @ViewChild('workArea', { static: true }) workArea: ElementRef;

  @HostBinding('style.max-height') maxHeight = '100%';
  public maxHeightPx = 0;
  public layer: SLLayer = null;
  @HostBinding('class.layer-edit') hasEditAccess = false;
  @HostBinding('class.layer-read') hasReadAccess = false;
  @HostBinding('class.layer-read-only') hasReadOnlyAccess = false;
  public node: any = {};
  public view: LayersViewComponent;
  public name = '';
  public opacity = 0;
  public searchable = false;
  public legendary = false;
  public tooltipOn = false;
  public labelable = false;
  public labelValueOverride = '';
  public layerVis = false;
  public pucVis = true;
  public labelStyle: LabelStyle = '';
  public fields: Array<any> = [];
  public layerDescription = '';
  public labelField: string;
  public hasFields = true;
  public readOnly = 'false';
  public isResultsView = false;
  public inheritLabelStyle = false;
  public inheritOnly = false;
  // tslint:disable-next-line: variable-name
  public _loaded = false;
  public adderName = '';
  public inheritable = false;
  private settingUp = true;

  @ViewChild('ioSet', { static: true }) ioSet: ButtonSetComponent;

  public get searchNavible() {
    return !this.isVirtual && (this.searchable === true);
  }

  public get stylable(): boolean {
    const canViewStyles = PermissionService.HasPermission(':Layers:Classifications:', PermissionService.VIEW);
    return !!this.layer && !this.isVirtual && this.layer.isVector && (Number(this.layer.access) >= LayerAccessLevel.Copy) && canViewStyles;
  }

  public get canExportGeom() {
    if (!this.layer) {
      return false;
    } else {
      return this.layer.canExportGeom;
    }
  }
  public set styleVisibility(vis: boolean) {
    // will not toggle other panels, just sets state
    this._stylesVisible = vis;
    this.cdr.detectChanges();

  }
  private _stylesVisible = false;
  public set stylesVisible(visState: boolean) {
    if (visState === this._stylesVisible) {
      return;
    }
    this._stylesVisible = visState;
    this.cdr.detectChanges();
    this.ToggleLayerStyles(this._stylesVisible);
    this.cdr.detectChanges();
    this.stylesVisibleChange.emit(this._stylesVisible);


  }
  public stylesVisibleChange = new EventEmitter<boolean>();
  public get stylesVisible(): boolean {
    return this._stylesVisible;
  }
  constructor(
    private popupTextEditor: ResultsPopupEditorDialogService,
    private stylesService: ModalResultStyleService,
    private messager: ModalMessagerService,
    private cdr: ChangeDetectorRef,
    private actionsSvc: ActionHandlerService) { }

  ngAfterViewInit() {
    this.ready.emit({ target: this });

  }
  UpdateSearchables() {

  }

  ToggleLayerStyles(stylesVisible?: boolean) {
    if ([null, undefined].indexOf(stylesVisible) > -1) {
      stylesVisible = !this.stylesVisible;
      this.stylesVisible = stylesVisible;
      this.cdr.detectChanges();
    }

    if (this.hasEditAccess === true) {
      if (this.layer && this.layer.isVector === true) {
        if (this.layer.type < LayerTypeEnum.Virtual_Results) {
          if (this.layer.map.src && this.layer.map.src.layerStyles) {
            switch (stylesVisible) {
              case true:
                this.layer.map.src.layerStyles.ShowClass(this.layer);
                if (this.layer.map.src.extendedViews) {
                  this.layer.map.src.extendedViews.SetView('layer-styles');
                }
                if (this.layer.map.src.panelSet) {
                  this.layer.map.src.panelSet.OpenExtended();
                }
                break;
              case false:
                if (this.layer.map.src.extendedViews) {
                  this.layer.map.src.extendedViews.SetView('none');
                }
                if (this.layer.map.src.panelSet) {
                  this.layer.map.src.panelSet.CloseExtended();
                }
            }

          }


        }
      }
    }
  }
  UpdateHeight(myPanel: any, maxHeight: number) {
    if (this.ioSet) {
      this.ioSet.proxy.ToggleDropDown(false);
    }
    myPanel = myPanel;
    this.maxHeightPx = maxHeight;
    this.maxHeight = 'calc(' + maxHeight + 'px' + ' - 0em)';
    this.SetHeight();
  }
  UpdateLayer(layer: SLLayer, node: any, view: LayersViewComponent) {
    if (layer.id === this.layer.id) {
      this.ShowLayer(layer, node, view);
    }
  }
  ShowLayer(layer: SLLayer, node: any, view: LayersViewComponent) {
    this.isResultsView = (layer.id === 'results');
    this.isParent = layer.hasSubLayers === true;
    this._loaded = false;
    this.layer = layer;
    this.layerVis = layer.GetLayerVis();
    this.isVirtual = layer.type >= LayerTypeEnum.Virtual_Results;
    this.inheritable = this.isVirtual;
    this.cdr.detectChanges();
    if (Number(this.layer.access) === 1) {
      this.hasReadOnlyAccess = true;
      this.hasReadAccess = true;
    }
    if (Number(this.layer.access) > 1) {
      this.hasReadOnlyAccess = false;
      this.hasReadAccess = true;
      this.hasEditAccess = true;
    }

    this.name = layer.name;
    this.node = node;
    this.view = view;
    this.layerDescription = layer.description;
    this.opacity = layer.opacity * 100;
    this.searchable = layer.searchable;
    this.legendary = layer.includeInLegend;
    this.tooltipOn = layer.tooltipOn;
    this.cdr.detectChanges();
    this.adderName = layer.ownerDisplay;
    this.GetLayerLabelInfo();
    this.readOnly = this.hasReadOnlyAccess ? 'true' : 'false';
    this.cdr.detectChanges();

    if (this.labelField === 'default') {
      if (!!layer.layerAttributes) {
        if (layer.layerAttributes.length > 0) {
          this.labelField = layer.layerAttributes[0].name;
          this.layer.labelAttribute = this.labelField;
        }
      }
    }
    this.settingUp = false;
    this.fields = [];
    if (!!this.layer.layerAttributes) {
      for (const att of this.layer.layerAttributes) {
        if (['1', true].indexOf(att.visible) > -1) {
          this.fields.push(att.name);
        }
      }
    } else {
      this.hasFields = false;
    }
    this.hasFields = this.fields.length > 0;
    this.cdr.detectChanges();
    this.Reload();
  }

  Reload() {
    setTimeout(() => this._loaded = false);
    setTimeout(() => {
      this._loaded = true;
      this.cdr.detectChanges();
      this.ready.emit({ target: this });
    });
  }
  Back() {
    this.stylesVisible = false;
    this.cdr.detectChanges();
    this.back.emit({ layer: this.layer });
  }

  HandleOpacityChange(event: number) {
    if (this.settingUp === true) { return; }
    this.layer.opacity = event / 100;
  }
  HandleSearchableChange(event: any) {
    if (this.settingUp === true) { return; }
    this.layer.searchable = event.checked;
    MapDataAction.UpdateSearchables(this.layer);
  }
  HandleLabelsOnChange(event: any) {
    this.cdr.detectChanges();
    this.labelable = event.value === 'true';
    if (this.settingUp === true) { return; }
    if (this.layer.IsVirtual() === true) {
      this.layer.SetLabelInfo(this.GetLabelInfo());
      this.layer.Touch();
      this.layer.Render();
      this.layer.SLMap.RefreshResultsIfLayer(this.layer);
      return;
    }
    if (this.layer.type > LayerTypeEnum.Virtual_Results) {
      // (this.layer as any).inheritLabels = event.value === 'inherit';
    }
    switch (event.value) {
      case 'true':
        this.layer.labelsOn = true;
        break;
      case 'false':
        this.layer.labelsOn = false;
        break;
    }

    this.layer.Touch();
    this.layer.Render();
    this.layer.SLMap.RefreshResultsIfLayer(this.layer);
  }
  HandleLabelOverrideChange(val: string) {
    if (this.layer.IsVirtual() === true) {
      this.layer.SetLabelInfo(this.GetLabelInfo());
      this.RefreshLayer();
      return;
    }

    this.layer.labelOverride = '';
    this.RefreshLayer();
  }

  HandleLegendInclChange(event: any) {
    if (this.settingUp === true) { return; }
    this.layer.includeInLegend = event.checked;
  }
  HandleTooltipChange(event: any) {
    if (this.settingUp === true) { return; }
    this.layer.tooltipOn = event.checked;
  }
  ZoomToFeatures() {
    this.layer.ZoomToFeatures();
  }
  RefreshLayer() {
    this.layer.Touch();
    this.layer.Render();
    this.cdr.detectChanges();
  }
  ToggleVisibility(event: any) {

    this.layer.SetLayerOn(event.value === 'true',
      this.layer.map);
    this.view.UpdateLayerVis(this.layer);
    this.cdr.detectChanges();

  }
  TogglePUCVisibility(event: any) {
    this.pucVis = event.value === 'true';
    this.cdr.detectChanges();
    this.layer.map.component.PUCMan.SetPUCVis(this.pucVis);
  }
  HandleLabelFieldChange(event: any) {
    if (this.layer.IsVirtual() === true) {
      this.layer.SetLabelInfo(this.GetLabelInfo());
      return;
    }
    this.layer.labelAttribute = event.target.value;

    this.RefreshLayer();
  }
  GetLabelInfo(): any {
    const labelInfo: any = {};
    labelInfo.labelField = this.labelField;
    labelInfo.override = ['_sl_override_or_inherit_', '_sl_override_'].indexOf(this.labelField) > -1;
    labelInfo.labelStyleJSON = this.labelStyle;
    labelInfo.inheritLabelStyle = this.inheritLabelStyle;
    labelInfo.labelsOn = this.labelable;
    labelInfo.labelOverride = this.labelValueOverride;
    return labelInfo;
  }
  GetLayerLabelInfo() {
    if (this.layer.IsVirtual() === true) {
      const info = this.layer.GetLabelInfo();
      this.labelField = info.labelField;
      this.labelStyle = info.labelStyleJSON;
      this.inheritLabelStyle = info.inheritLabelStyle;
      this.inheritOnly = info.inheritOnly;
      this.labelValueOverride = info.labelOverride;
      this.labelable = info.labelsOn;
    } else {
      this.labelField = this.layer.labelAttribute;
      this.labelStyle = this.layer.labelStyle;
      this.labelValueOverride = this.layer.labelOverride;
      this.inheritLabelStyle = false;
      this.inheritOnly = false;
      this.labelable = this.layer.labelsOn;
    }
    this.cdr.detectChanges();
  }
  EditPopupText() {
    this.HideIOSet();
    this.popupTextEditor.Show(() => {

    }, this.layer);
  }
  SaveLayer() {
    this.layer.PromptSave();
  }
  LoadLayer() {
    this.layer.PromptLoad();
  }
  ExportLayer() {
    this.layer.PromptExport();
  }
  StyleUpdated() {
    if (this.layer.IsVirtual()) {
      this.layer.SetLabelInfo(this.GetLabelInfo());
      this.RefreshLayer();
      return;
    }
    this.layer.labelStyle = this.labelStyle;
    this.RefreshLayer();
  }
  public isInputs = false;
  Config() {
    let type = 'selected';
    if (this.layer.type === LayerTypeEnum.Virtual_SelectedResults) {
      type = 'selected';
    }
    if (this.layer.type === LayerTypeEnum.Virtual_UnSelectedResults) {
      type = 'unselected';
    }
    if (this.layer.type === LayerTypeEnum.Virtual_Input) {
      type = 'inputs';
    }
    this.stylesService.GetStyles((data: any) => {
      data = null;
      this.layer.Render();
    }, this.layer.SLMap as ISLMap, type);
  }
  private SetHeight() {
    // this.domNode.nativeElement.style.height = 'calc(' + this.maxHeight + ' - 4.1em)'; // this.maxHeight;
    $(this.workArea.nativeElement).css('height', 'fit-content');
    // const workArea = this.workArea.nativeElement;
    $(this.workArea.nativeElement).css('max-height', 'calc(' + this.maxHeight + ' - 4.25rem)');
    this.cdr.detectChanges();
  }
  RemoveLayer() {
    let message = 'You are about to remove this layer entry from this map.<br>';
    message += 'The layer will still be in the system but no longer included in this map.';
    message += ' Any classifications or map-specific information will be lost for this layer';
    message += ' Are you sure you wish to procede?';
    this.messager.Confirm(message, () => {
      this.layer.RemoveFromProject(() => {
        this.back.emit({ layer: 'removed' });
      });
    }, () => { }, 'Confirm Layer Removal!');
  }
  HideIOSet() {
    if (!this.ioSet) return;
    this.ioSet.proxy.ToggleDropDown(false);
  }
  GoToSearch() {
    this.HideIOSet();
    this.layer.map.GoToSearch(this.layer);
  }
  public SwitchToListMoment() {
    (this.layer as ResultsLayer).SendToResults();
    (this.layer as ResultsLayer).RequestRender('results-list');
    this.layer.SLMap.ShowResultsView();
  }
  public SwitchToPucMoment() {
    const layer: ResultsLayer = this.layer as ResultsLayer;
    layer.SendToPUC();
    layer.RequestRender('popup-control');

  }
  public SwitchToInfoMoment() {
    (this.layer as ResultsLayer).SendToInfo();
    (this.layer as ResultsLayer).RequestRender('info');


  }
  ListHasMoment() {
    if (!this.layer) {
      return false;
    }
    const layer = (this.layer as ResultsLayer);
    return layer.hasMoment || layer.hasHistory || layer.hasMoment;
  }
  PucHasMoment() {
    if (!this.layer) {
      return false;
    }
    const layer = (this.layer as ResultsLayer);
    return layer.hasMoment || layer.hasHistory || layer.pucHasMoment;
  }
  InfoHasMoment() {
    if (!this.layer) {
      return false;
    }
    const layer = (this.layer as ResultsLayer);
    return layer.hasMoment || layer.hasHistory || layer.pucHasMoment;
  }
  EditAttributes() {
    if (!this.layer) {
      return false;
    }
    this.HideIOSet();
    const attsView = DisplayAction.SetPrimaryView('layer-attributes-view');
    if (!!attsView) {
      (attsView as LayerAttributesViewComponent).SetLayer(this.layer);
    }
  }
  IsResultsSynched(layer: SLLayer, target: string): boolean {
    if (layer instanceof ResultsLayer) {
      return (layer as ResultsLayer).IsSynched(target);
    }
    return false;
  }
  IsLabelDisabled() {
    if (this.layer.IsVirtual() === false) {
      return false;
    }
    if (this.inheritOnly === false) {
      return false;
    }
    return this.inheritLabelStyle === true;
  }
  HasMoment() {
    return (this.layer as ResultsLayer)?.hasMoment;
  }
  HasSpatialMoment():boolean {
    return false;
    if (!this.HasMoment()) return false;
    return (this.layer as ResultsLayer)?.hasSpatialMoment;
  }
  ClearMoment() {
    const layer = this.layer as ResultsLayer;
    layer.ClearResults();
    const results = layer.map.src.resultsView as ResultsViewComponent;
    results.ClearAll();
    if (layer.map.src.secondaryViews.currentView.viewName === 'attribute') {
      (layer.map.src.attributeView as AttributeViewComponent).Reset();
      MapDataAction.Exec('map data/legend-toggle', layer.SLMap.component);
    }
    const pucMan = this.layer.SLMap.component.PUCMan;
    pucMan.HidePUC();
    pucMan.HidePopup();


  }
  ReQuery() {
    // if(this.layer.name !== 'Input Features') return;
    // this.actionsSvc.HandleAction('info/re-query')
  }

}

